(function () {
    'use strict';

    var STAR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 1l1.88 3.82 4.22.61-3.05 2.97.72 4.19L8 10.5 4.23 12.59l.72-4.19L1.9 5.43l4.22-.61L8 1z"/></svg>';

    function renderStars(count) {
        var html = '';
        for (var i = 0; i < count; i++) {
            html += '<span class="c-reviews-slider__star">' + STAR_SVG + '</span>';
        }
        return html;
    }

    function initSlider(section) {
        var reviews;
        try {
            reviews = JSON.parse(section.dataset.reviews || '[]');
        } catch (e) {
            return;
        }
        if (reviews.length < 2) return;

        var quoteText   = section.querySelector('.c-reviews-slider__quote-text');
        var authorEl    = section.querySelector('.c-reviews-slider__author');
        var starsEl     = section.querySelector('.c-reviews-slider__stars');
        var productImg  = section.querySelector('.c-reviews-slider__product-img');
        var quoteCard   = section.querySelector('.c-reviews-slider__quote');
        var productWrap = section.querySelector('.c-reviews-slider__product');
        var btns        = section.querySelectorAll('.c-reviews-slider__btn');

        var current = 0;

        function show(index) {
            quoteCard.style.opacity   = '0';
            productWrap.style.opacity = '0';

            setTimeout(function () {
                var r = reviews[index];
                if (quoteText)  quoteText.textContent = r.quote  || '';
                if (authorEl)   authorEl.textContent  = r.author || '';
                if (starsEl)    starsEl.innerHTML     = renderStars(r.stars || 5);
                if (productImg) {
                    productImg.src = r.imageUrl || '';
                    productImg.alt = r.imageAlt || '';
                }
                quoteCard.style.opacity   = '1';
                productWrap.style.opacity = '1';
                current = index;
            }, 150);
        }

        btns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var dir = parseInt(btn.dataset.dir, 10) || 1;
                show((current + dir + reviews.length) % reviews.length);
            });
        });
    }

    document.querySelectorAll('.c-reviews-slider[data-reviews]').forEach(initSlider);
})();
